

export const ConverterTypes = {
  ELEMENT: 'element',
  OPTION: 'option',
  TEXT: 'text'
}